import {
  DesktopLayoutBoxed,
  DesktopLayoutBoxedContent,
} from '@kanda-libs/ks-design-library';

import Content from './Content';

const Desktop: React.FunctionComponent = function () {
  return (
    <DesktopLayoutBoxed>
      <DesktopLayoutBoxedContent>
        <Content />
      </DesktopLayoutBoxedContent>
    </DesktopLayoutBoxed>
  );
};

export default Desktop;
